function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.4891 18.7496C10.7363 17.2978 12.7384 18.1777 13.5381 16.8406C14.0114 16.052 13.3963 15.6189 13.8346 14.002C14.0256 13.2975 14.3217 12.2201 15.2902 11.561C16.2904 10.8793 17.6885 10.8335 18.6937 11.3089C19.5621 11.7196 19.8234 12.3703 20.2298 12.2362C20.6716 12.0895 20.471 11.275 21.1283 10.0798C21.3544 9.66371 21.6768 9.08821 22.3295 8.68988C23.3146 8.0931 24.4139 8.30757 24.7011 8.36388C24.9695 8.41552 25.3254 8.52108 26.1442 8.98362C28.15 10.1121 28.1047 10.668 28.8614 10.7665C30.1866 10.9456 30.6378 9.30141 32.3047 9.24461C33.3596 9.20798 34.172 9.84323 34.7246 10.2761C35.1447 10.6086 36.6425 11.8734 37.3245 15.1288C38.2368 19.4719 36.8262 23.1977 36.259 24.6448C35.1404 27.4878 33.6823 31.2079 29.7014 33.2119C29.4888 33.3163 25.1348 35.4367 20.7711 33.942C19.3802 33.4683 18.0254 32.6351 17.5075 32.3149C15.8407 31.2923 14.724 30.2831 13.9039 29.5313C12.7973 28.5184 11.6576 27.4606 10.5228 25.7818C9.61892 24.4465 8.92603 23.3992 8.78224 21.8544C8.71416 21.1402 8.62946 19.7446 9.4891 18.7496Z",
  fill: "#88B5E1",
  stroke: "url(#paint0_linear)",
  strokeWidth: 3,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.8219 21.2106C22.0088 21.6208 20.7126 19.4431 18.7882 20.1772C18.0231 20.468 17.5557 21.067 17.2332 21.4835C17.1049 21.6487 16.0807 23.0093 16.1722 24.8683C16.2909 27.2004 18.0792 28.6737 18.9561 29.3938C20.3068 30.5012 21.7163 30.9795 22.6685 31.1955C23.4411 31.4019 25.3173 31.7872 27.4061 30.9886C29.4093 30.2206 30.4744 28.7999 31.1269 27.9245C32.5782 25.9793 32.9242 24.0887 32.9902 23.7015C33.2239 22.3227 33.4942 20.6808 32.525 19.1472C31.5577 17.6187 29.4752 16.387 27.8262 16.8748C25.6258 17.5202 25.9127 20.7351 23.8219 21.2106Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.7464 20.9642C16.0772 21.6979 15.8465 22.7519 15.174 23.3334C14.2624 24.1197 12.8536 23.7547 12.0556 23.1597C11.1579 22.4925 10.5386 21.1746 10.9641 20.4429C11.6276 19.2966 15.023 19.3711 15.7464 20.9642Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.007 16.9066C32.2625 17.2071 31.2193 16.9271 30.6676 16.2269C29.9194 15.279 30.3492 13.8925 30.9769 13.1225C31.6837 12.256 33.0283 11.6954 33.737 12.1519C34.8524 12.8718 34.6271 16.2587 33.007 16.9066Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.2375 16.7499C20.0329 17.5275 19.1881 18.199 18.2987 18.2219C17.0949 18.255 16.2336 17.0862 15.9908 16.1222C15.7167 15.0386 16.0681 13.6234 16.8601 13.3286C18.095 12.8583 20.6775 15.0586 20.2375 16.7499Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.8536 15.331C25.3668 15.971 24.3243 16.2646 23.4951 15.9477C22.3691 15.5156 22.0286 14.1036 22.1762 13.1192C22.3432 12.0142 23.2092 10.8465 24.054 10.8736C25.3763 10.9174 26.9144 13.9459 25.8536 15.331Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M41.5286 29L48.0238 40.25H35.0334L41.5286 29Z",
  fill: "#9188AB"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 2.24688,
  y1: 16.8519,
  x2: 44.5639,
  y2: 29.959,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9188AB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5685B3"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  y: 13.5049,
  width: 40.0829,
  height: 31.0811,
  transform: "rotate(-19.6893 0 13.5049)",
  fill: "white"
})));

var SvgCommentLikeButton = function SvgCommentLikeButton(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 43,
    viewBox: "0 0 49 43",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCommentLikeButton, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/comment-like-button.125ea67f.svg";
export { ForwardRef as ReactComponent };